import { useMutation, useQueryClient } from 'react-query';
import axios from 'axios';
import { useContext } from 'react';
import { AuthContext } from '../../Context/AuthContext';

const useRejectMerchant = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();

  return useMutation(
    async (merchantId) => {
      const response = await axios.delete(
        `${process.env.REACT_APP_SERVER_URL}/users/merchant/delete/${merchantId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response.data;
    },
    {
      onSuccess: (_data, merchantId) => {
        queryClient.invalidateQueries('merchants');
        queryClient.invalidateQueries(['user', merchantId]);
        queryClient.invalidateQueries(['businessMerchant', merchantId]);
      },
    }
  );
};

export default useRejectMerchant;
